import React from 'react'

export const AlertIcon: React.FC = (): JSX.Element => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ minWidth: 24 }}>
      <path fillRule="evenodd" clipRule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-.833-15.833V14.5h1.666V6.167h-1.666Zm0 11.666v-1.666h1.666v1.666h-1.666Z" fill="var(--color-warning-600)" />
    </svg>
  )
}
